import React from "react";
import http from "../../utils/http";

/**
 * Component to handle file upload. Works for image
 * uploads, but can be edited to work for any file.
 */
function FileUpload({ id, onSave }) {
  // State to store uploaded file
  const [file, setFile] = React.useState("");

  // Handles file upload event and updates state
  function handleUpload(event) {
    setFile(event.target.files[0]);

    // Add code here to upload file to server
    http(`files/post/client/${id}`).asFile(event.target.files[0]).then(() => onSave());
  }

  return (
    <div id="upload-box">      
      <input type="file" onChange={handleUpload} />
      {file && <ImageThumb image={file} />}
    </div>
  );
}

/**
 * Component to display thumbnail of image.
 */
const ImageThumb = ({ image }) => {
  return <img className="img-photo" src={URL.createObjectURL(image)} alt={image.name} />;
};

FileUpload.defaultProps = {
  onSave : () => {}
}

export default FileUpload